import { getAttribute } from '../get-attribute';
import type { SetAttributesFunction } from '../types';
import { updateAttributes } from '../update-attributes';

/**
 * Creates an attribute manager for handling nested attribute updates
 *
 * @param attributes - Current block attributes
 * @param setAttributes - Function to update block attributes
 * @returns Object with utility functions for updating attributes
 */
export const createAttributeManager = < T extends Record< string, unknown > >(
	attributes: T,
	setAttributes: SetAttributesFunction< T >,
) => {
	return {
		updateAttributes: ( path: string, value: unknown ) =>
			updateAttributes( attributes, setAttributes, path, value ),
		getAttribute: < TValue = unknown >(
			path: string,
			defaultValue?: TValue,
		) => getAttribute< T, TValue >( attributes, path, defaultValue ),
	};
};
